import { onMounted, toRefs, reactive, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  name: "App",

  setup() {
    const $store = useStore(); //获取store仓库对象

    const route = useRoute();
    const state = reactive({
      includeList: []
    });
    onMounted(() => {
      if ($store.state.user.Authorization) {
        //token存在,则获取购物车请求
        $store.dispatch("setReqCarNum");
      }
    }); //监视路由的改变,如果改变了,添加进入

    watch(() => route, (newVal, oldVal) => {
      if (newVal.meta.keepAlive && state.includeList.indexOf(newVal.name) === -1) {
        state.includeList.push(newVal.name);
      }
    }, {
      deep: true
    }); // 开启深度监听

    return { ...toRefs(state)
    };
  }

};